<template>
<div class="partner">
  <div class="cont">
  <!-- 经典案例 -->
    <div class="title" >
    <div class="p1">
      <img src="../assets/img/s-back.png" alt="">
    </div>
    <div class="p2">
      <img src="../assets/img/s-back.png" alt="">
    </div>
      <div>
        <div class="box1"></div>
        <div class="box2" style=" font-size: 1.456rem;">经典案例</div>
      </div>
      <div class="title_b">
        <div class="ert" style="position: relative; " @mouseenter="str()" @mouseleave="str()">
              <div v-show="flag" class="er" >
              </div>
              <img  v-show="flag" src="../assets/img/er_wh.jpg" alt="">
              <img  src="../assets/img/wh_case.jpg" style="width: 100%;height: 100%;" alt="">
            </div>
        <!-- 梦想城 -->
            <div class="ert" style="position: relative; " @mouseenter="str1()" @mouseleave="str1()">
              <div v-show="flag1" class="er" >
              </div>
              <img  v-show="flag1" src="../assets/img/er_mx.jpg" alt="">
              <img  src="../assets/img/drem_case.jpg" style="width: 100%;height: 100%;" alt="">
            </div>
            <!-- 长白 -->
            <div class="ert" style="position: relative; " @mouseenter="str2()" @mouseleave="str2()">
              <div v-show="flag2" class="er" >
              </div>
              <img  v-show="flag2" src="../assets/img/er_cb.jpg" alt="">
              <img  src="../assets/img/cb_case.jpg" style="width: 100%;height: 100%;" alt="">
            </div>
            <!-- 西市 -->
            <div class="ert" style="position: relative; " @mouseenter="str3()" @mouseleave="str3()">
              <div v-show="flag3" class="er" >
              </div>
              <img  v-show="flag3" src="../assets/img/er_xs.jpg" alt="">
              <img  src="../assets/img/xs_case.jpg" style="width: 100%;height: 100%;" alt="">
            </div>
      </div>
    </div>
    <!-- 合作商户-->
    <div class="merchant" style="    margin-top: 6.24rem;position: relative;">
      <div class="merchant_t">
        <div class="box1" style="float: right;"></div>
        <div class="box2" style=" font-size: 1.456rem;">合作商户</div>
      </div>
      <!-- <div class="merchant_b">
        <div><img src="../assets/img/btt.png" alt=""></div>
      </div> -->
      <div style="position: absolute;left: -3.328rem;width: 1.404rem;height: 3.796rem;top: 13.48rem;"><img style="width: 100%;height: 100%;" src="../assets/img/arrow_l.png" alt=""></div>
      <div style="position: absolute;right: -3.328rem;width: 1.404rem;height: 3.796rem;top: 13.48rem;"><img style="width: 100%;height: 100%;" src="../assets/img/arrow_r.png" alt=""></div>
      <div class="contr " style="overflow: hidden;margin-top: 2.132rem;">
        <div class="contrc" style="width: 155rem;margin-top: 6.12rem;">
          <div class="contrc1">
              <img src="../assets/img/1.png" alt="">
          </div>
          <div class="contrc1">
              <img src="../assets/img/2.png" alt="">
          </div>
          <div class="contrc1">
              <img src="../assets/img/3.png" alt="">
          </div>
          <div class="contrc1">
              <img src="../assets/img/4.png" alt="">
          </div>
          <div class="contrc1">
              <img src="../assets/img/5.png" alt="">
          </div>
          <div class="contrc1">
              <img src="../assets/img/6.png" alt="">
          </div>
          <div class="contrc1">
              <img src="../assets/img/7.png" alt="">
          </div>
          <div class="contrc1">
              <img src="../assets/img/8.png" alt="">
          </div>
          <div class="contrc1">
              <img src="../assets/img/9.png" alt="">
          </div>
          <div class="contrc1">
              <img src="../assets/img/10.png" alt="">
          </div>
          <div class="contrc1">
              <img src="../assets/img/11.png" alt="">
          </div>
          <div class="contrc1">
              <img src="../assets/img/1.png" alt="">
          </div>
          <div class="contrc1" style="margin-right: 0;">
              <img src="../assets/img/2.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
    <!-- 底部 -->
    <div class="food">
      <div class="food_t" style="20px">
        <div class="food_l">
          <p>ADRESS：</p>
          <p>陕西省西安市雁塔区雁塔南路885号西安金辉环球广场</p>
        </div>
        <div class="food_r">
          <div>联系我们：</div>
          <div><img style="width: 100%;" src="../assets/img/erm.jpg" alt=""></div>
        </div>
      </div>
      <div class="food_b" style="16px">Copyright © 2018 企鹅互动网络版权所有[官方网站]   <a style="color:#FFF;" href="https://beian.miit.gov.cn/" target="_blank">陕ICP备16018502号-2</a></div>
    </div>

</div>
</template>
<script>
export default {
  name: "partner",
  data () {
    return {
       flag:false,
       flag1:false,
       flag2:false,
       flag3:false
    };
  },
  methods:{
    str(){
      this.flag = !this.flag
    },
    str1(){
      this.flag1 = !this.flag1
    },
    str2(){
      this.flag2 = !this.flag2
    },
    str3(){
      this.flag3 = !this.flag3
    }
  }
}
</script>
<style scoped>


  html{
    font-size:1vw;
  }

  @keyframes move2{
      0%{
         transform: translateX(0);
      }
      100%{
         transform: translateX(-72rem);
      }
  }


.cont{
  width: 61%;
  margin: 0 21%;
  margin-top: -2.08rem;
}
.cont>div{
  width: 100%;
}
.box1{
  width: 36%;
  height: 2px;
  background: #FFCE00;
}
.box2{
  font-size: 1.144rem;
  font-weight: bold;
  margin: 1.144rem 0 3.276rem 0;;
}
/* 经典案例 */

.title_b{
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.title_b>div{
  width: 21%;
}

.title_b>div>img{
  width: 100%;
}


.er{
  position: absolute;
  width: 100%;
  height: 100%;
  background: #000000;
  opacity: .7;
}
.er>img{
  width: 90%;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
  position: absolute;
  margin: auto
}
.ert img:nth-child(2){
  width: 90%;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
  position: absolute;
  margin: auto
}
.ert{
  border: 4px solid #000000;
  border-radius: 10px;
  height: 25.636rem;
}

/* 合作商户 */
.merchant_t{
  float: right;
}
.merchant_b{
  width: 100%;
}
.merchant_b>div{
  width: 100%;
}
.merchant_b>div>img{
  width: 100%;
}



/* 漂浮 */
 .p1{
      width: 35%;
      height: 10.92rem;
      position: absolute;
      left: -6.864rem;
      margin-top: -6.344rem;
      z-index: -1;
  }
  .p1>img{
    width: 100%;
  }
  .p2{
      width: 34%;
      height: 17.16rem;
      position: absolute;
      margin-top: 27.3rem;
      right: 0;
      overflow: hidden;
      z-index: -1;
  }
  .p2>img{
    width: 100%;
    position: absolute;
    right:-13.312rem ;
  }
/* 底部 */
.food{
  width: 100%;
  height: 11.596rem;
  background: #333333;
  color: #FFFFFF;
  margin-top: 1.976rem;
}
.food_t{
  width: 58%;
  margin: 0 21%;
  padding-top: 2.132rem;
}
.food_t>div{
  display: inline-block;
  vertical-align: middle;
}
.food_b{
  text-align: center;
}
.food_l{
      margin-top:1.04rem;
      line-height: 1.56rem;
}
.food_r{
  float: right;
}
.food_r>div{
  display: inline-block;
  vertical-align: middle;
}
.food_r>div:nth-child(2){
  width: 5.72rem;
  height: 5.72rem;
  background: #FFFFFF;
  border-radius: 10px;
}
.food_b{
  margin-top: 1.56rem;
  font-size: 0.624rem;
}

.contrc1{
  display: inline-block;
  width: 10.4rem;
  margin-right: 1rem;
  animation: move2 50s linear infinite;
}
.contrc1 img{
  width: 100%;
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/partner.vue